import React from "react"
import Layout from "src/components/Layout"
import SINHALA_COURSES from "src/data/courses/sinhala_courses_list"
import Card from "src/components/cards/Card"
import { Link } from "gatsby"

export default function SinhalCourses() {
  const courses = SINHALA_COURSES

  return (
    <Layout>
      <div className="container" key={Math.random().toString()}>
        <h1 className="heading">Sinhala Courses</h1>
        <div className="card_grid">
          {courses.map(course => (
            <Link to={course.slug} key={course.slug}>
              <Card>
                <h1 className="heading">{course.title}</h1>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  )
}
